<template>
    <div class="row mx-0 mt-3">
        <p v-if="!expired" class="col-12 p-0 my-0">Time Remaining: {{time}}</p>
        <p v-if="expired" class="col-12 p-0 my-0">Time Remaining: <span class="error">EXPIRED</span></p>
        <p v-if="resendCodeShow" role="alert" aria-live="assertive" class="col-12 p-0 my-0">{{resendCodeMsgText}}</p>
        <p class="col-12 p-0">{{timerActiveText}} {{initialTime}} minutes.</p>
    </div>
</template>

<script>
    export default {
        name: "Timer",

        props: {
            timerActiveText: String,
            resendCodeMsgText: String,
            resendCodeShow: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
            return {
                time: "00:00",
                initialTime: 0,
                minutes: 0,
                seconds: 0,
                timer: null,
                expired: false
            }
        },

        methods: {
            setTime: function(seconds) {
                this.seconds = seconds % 60;
                this.minutes = Math.floor(seconds / 60);
                this.initialTime = Math.round(seconds / 60);
                this.updateTime();
                this.expired = false;
            },

            startTimer: function() {
                this.timer = setInterval(function(){
                    this.countdown();
                }.bind(this), 1000);
            },

            stopTimer: function() {
                clearInterval(this.timer);
            },

            restartTimer: function(seconds) {
                this.stopTimer();
                this.setTime(seconds);
                this.startTimer();
            },

            isExpired: function() {
                return this.expired;
            },

            countdown: function() {
                if (this.seconds === 0) {
                    if (this.minutes === 0) {
                        this.expired = true;
                        this.stopTimer();
                    }
                    else {
                        this.minutes--;
                        this.seconds = 59;
                    }
                }
                else {
                    this.seconds--;
                }

                this.updateTime();
            },

            updateTime: function() {
                var time = ""
                if (this.minutes < 10) {
                    time += "0";
                }

                time += this.minutes + ":";

                if (this.seconds < 10) {
                    time += "0";
                }

                time += this.seconds;
                this.time = time;
            }
        }
    }
</script>
